import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PurchaseReleaseDetail_Create, PurchaseReleaseDetail_Update, PurchaseReleaseDetail_Delete, PurchaseReleaseDetail_ReadAll, PurchaseReleaseDetail_ReadById, PurchaseReleaseDetail_ReadByItemId, PurchaseReleaseDetail_ReadByReleaseId, PurchaseReleaseDetail_ReadByReleaseIdForImport, PurchaseReleaseDetail_ReadByInvoiceIdForImport, PurchaseReleaseDetail_CreateBulk, PurchaseReleaseDetail_UpsertBulk } from 'src/app/GlobalVariables';
import { PurchaseReleaseDetailCreateRequestDTO, PurchaseReleaseDetailDTO, PurchaseReleaseDetailUpdateRequestDTO, PurchaseReleaseDetailDeleteRequestDTO, PurchaseReleaseDetailList, PurchaseReleaseDetailReadByIdRequestDTO, PurchaseReleaseDetailReadByItemIdRequestDTO, PurchaseReleaseDetailReadByReleaseIdRequestDTO, PurchaseReleaseDetailReadByReleaseIdForImportRequestDTO, PurchaseReleaseDetailReadByInvoiceIdForImportRequestDTO, PurchaseReleaseDetailCreateBulkRequestDTO, PurchaseReleaseDetailUpsertBulkRequestDTO } from './purchase-release-detail.interface';

@Injectable({
  providedIn: 'root'
})
export class PurchaseReleaseDetailService {

  constructor() { }

  http = inject(HttpClient);

  PurchaseReleaseDetail_Create(data: PurchaseReleaseDetailCreateRequestDTO): Observable<PurchaseReleaseDetailDTO> {
    return this.http.post<PurchaseReleaseDetailDTO>(PurchaseReleaseDetail_Create, data);

  }

  PurchaseReleaseDetail_Update(data: PurchaseReleaseDetailUpdateRequestDTO): Observable<PurchaseReleaseDetailDTO> {
    return this.http.post<PurchaseReleaseDetailDTO>(PurchaseReleaseDetail_Update, data);
  }

  PurchaseReleaseDetail_Delete(data: PurchaseReleaseDetailDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(PurchaseReleaseDetail_Delete, data);
  }

  PurchaseReleaseDetail_ReadAll(): Observable<PurchaseReleaseDetailList> {
    return this.http.get<PurchaseReleaseDetailList>(PurchaseReleaseDetail_ReadAll);
  }

  PurchaseReleaseDetail_ReadById(data: PurchaseReleaseDetailReadByIdRequestDTO): Observable<PurchaseReleaseDetailDTO> {
    return this.http.post<PurchaseReleaseDetailDTO>(PurchaseReleaseDetail_ReadById, data);
  }

  PurchaseReleaseDetail_ReadByReleaseId(data: PurchaseReleaseDetailReadByReleaseIdRequestDTO): Observable<PurchaseReleaseDetailList> {
    return this.http.post<PurchaseReleaseDetailList>(PurchaseReleaseDetail_ReadByReleaseId, data);
  }

  PurchaseReleaseDetail_ReadByReleaseIdForImport(data: PurchaseReleaseDetailReadByReleaseIdForImportRequestDTO): Observable<PurchaseReleaseDetailList> {
    return this.http.post<PurchaseReleaseDetailList>(PurchaseReleaseDetail_ReadByReleaseIdForImport, data);
  }

  PurchaseReleaseDetail_ReadByItemId(data: PurchaseReleaseDetailReadByItemIdRequestDTO): Observable<PurchaseReleaseDetailList> {
    return this.http.post<PurchaseReleaseDetailList>(PurchaseReleaseDetail_ReadByItemId, data);
  }

  PurchaseReleaseDetail_ReadByInvoiceIdForImport(data: PurchaseReleaseDetailReadByInvoiceIdForImportRequestDTO): Observable<PurchaseReleaseDetailList> {
    return this.http.post<PurchaseReleaseDetailList>(PurchaseReleaseDetail_ReadByInvoiceIdForImport, data);
  }

  PurchaseReleaseDetail_CreateBulk(data: PurchaseReleaseDetailCreateBulkRequestDTO): Observable<void> {
    return this.http.post<void>(PurchaseReleaseDetail_CreateBulk, data);
  }

  PurchaseReleaseDetail_UpsertBulk(data: PurchaseReleaseDetailUpsertBulkRequestDTO): Observable<PurchaseReleaseDetailList> {
    return this.http.post<PurchaseReleaseDetailList>(PurchaseReleaseDetail_UpsertBulk, data);
  }

}
